export function HangerIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden>
      <circle cx="24" cy="9" r="3.2" stroke="currentColor" strokeWidth="2" />
      <path d="M24 12.2v2.2L9 27h30L24 14.4" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M11 27c1.8 8 5.4 13 13 13s11.2-5 13-13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
